import { Base, Component, Mixins, Prop } from '@/vue-property-decorator'
import AdvertisementBox from '../components/advertisementBox'
import BasePropsConfig, { VerticalProps } from '../components/basePropsConfig'
import BoxCut from '../../components/boxCut'
import FallbackBackground from '../../components/fallbackBackground'
import FavoriteIcon from '../../components/favoriteIcon'
import GamePlatformName from './gamePlatformName'
import LabelGameStatus from '../../components/labelGameStatus'
import MaskMaintain from '../../components/maskMaintain'
import OuterBox from '../components/outerBox'
import style from './style.module.scss'
const ExhibitFallbackBg = FallbackBackground.ExhibitFallbackBg

/** cssSizeType的样式类型 */
export enum VerticalBottomNameCssSizeType {
  Default = 'default',
  Small = 'small'
}
type Props = VerticalProps & {
  /** 样式 */
  cssSizeType?: VerticalBottomNameCssSizeType
}

/** 收藏图标 后面可能要扩展出未收藏和已收藏两种状态,后面再说*/
@Component<VerticalBottomName>({
  name: 'VerticalBottomName'
})
export default class VerticalBottomName extends Mixins<
  Base<unknown, Props>,
  BasePropsConfig
>(Base, BasePropsConfig) {
  /** 样式尺寸类型 */
  public static CssSizeType = VerticalBottomNameCssSizeType
  /** 获得props */
  public static getProps = BasePropsConfig.getProps

  @Prop({ default: 'default' })
  protected cssSizeType!: Required<Props>['cssSizeType']

  /** 控制显示背景图 */
  private exhibitFallbackBg = new ExhibitFallbackBg()

  /** 渲染广告图内部 */
  private renderAdvertiseInner() {
    const { isCustomIcon } = this.cardProps
    // 若是业主自定义的图,则不再显示我们写入的游戏名称
    if (isCustomIcon) {
      return undefined
    }
    // 如果有使用自定义插槽,则优先渲染它
    if (this.$scopedSlots.gameName) {
      return this.$scopedSlots.gameName()
    }
    return <GamePlatformName />
  }

  render() {
    const { isMaintain, isFavorited, isShowFavorited } = this.cardProps
    const { status } = this.cardProps
    const { cssSizeType } = this
    return (
      <OuterBox
        class={{
          ['vertical-bottom-name']: true,
          [style['vertical-bottom-name']]: true,
          [style[`type-${cssSizeType}`]]: true
        }}
        onClick={this.handleClickCard}
      >
        <BoxCut>
          {/* 兜底背景图 */}
          {this.exhibitFallbackBg.isShow && (
            <FallbackBackground></FallbackBackground>
          )}
          {/* 广告图 */}
          <AdvertisementBox
            onLoadedResult={this.exhibitFallbackBg.setIsShowBgByAdvertiser}
          >
            {this.renderAdvertiseInner()}
          </AdvertisementBox>
          <template slot="cutSuspense">
            {/* 游戏状态标签 */}
            {status &&
              (this.$scopedSlots.labelGameStatus?.() || <LabelGameStatus />)}
            {/* 维护状态悬浮层 */}
            {isMaintain && <MaskMaintain />}
          </template>
          {/* unCut插槽中的元素,不会被overflow:hidden裁剪 */}
          <template slot="unCutSuspense">
            {isShowFavorited && (
              <FavoriteIcon
                isFavorited={isFavorited}
                onClick={this.handleClickFavorIcon}
              >
                <FavoriteIcon.CircleStar></FavoriteIcon.CircleStar>
              </FavoriteIcon>
            )}
          </template>
        </BoxCut>
      </OuterBox>
    )
  }
}
